// code : 1 start

// import { useEffect, useState } from "react";

// const TypingEffect = ({ text, onComplete }) => {
//   const [displayedText, setDisplayedText] = useState("");

//   useEffect(() => {
//     let index = 0;
//     const interval = setInterval(() => {
//       setDisplayedText((prev) => prev + text.charAt(index));
//       index++;
//       if (index >= text.length) {
//         clearInterval(interval);
//         if (onComplete) onComplete(); // notify parent
//       }
//     }, 30); // typing speed in ms per character

//     return () => clearInterval(interval);
//   }, [text, onComplete]);

//   return <span dangerouslySetInnerHTML={{ __html: displayedText }} />;
// };

// export default TypingEffect;

// code : 1 end
// code : 2 start
// import React, { useEffect, useState } from "react";
// export default function TypingEffect({ text, onComplete }) {
//   const [displayed, setDisplayed] = useState("");

//   useEffect(() => {
//     const tokens = tokenizeHTML(text);
//     let output = "";
//     let tokenIndex = 0;
//     let charIndex = 0;

//     const type = () => {
//       if (tokenIndex >= tokens.length) {
//         if (onComplete) onComplete();
//         return;
//       }

//       const currentToken = tokens[tokenIndex];

//       if (currentToken.type === "tag") {
//         // Instantly add tags
//         output += currentToken.value;
//         setDisplayed(output);
//         tokenIndex++;
//         type();
//       } else {
//         // Type text tokens character by character
//         if (charIndex < currentToken.value.length) {
//           output += currentToken.value.charAt(charIndex);
//           setDisplayed(output);
//           charIndex++;
//           setTimeout(type, 30);
//         } else {
//           charIndex = 0;
//           tokenIndex++;
//           type();
//         }
//       }
//     };

//     type();
//   }, [text, onComplete]);

//   return (
//     <span dangerouslySetInnerHTML={{ __html: displayed }} />
//   );
// }

// function tokenizeHTML(input) {
//   const regex = /(<[^>]+>)|([^<]+)/g;
//   const tokens = [];
//   let match;
//   while ((match = regex.exec(input))) {
//     if (match[1]) tokens.push({ type: "tag", value: match[1] });
//     if (match[2]) tokens.push({ type: "text", value: match[2] });
//   }
//   return tokens;
// }

// code : 2 end
// code : 3 start
// import React, { useEffect, useRef, useState } from "react";
// export default function TypingEffect({ text, animate, onComplete }) {
//   const [displayed, setDisplayed] = useState(animate ? "" : text);
//   const outputRef = useRef("");
//   const tokenIndexRef = useRef(0);
//   const charIndexRef = useRef(0);
//   const typingTimeout = useRef(null);

//   useEffect(() => {
//     if (!animate) {
//       setDisplayed(text);  // instantly show full text
//       return;
//     }

//     const tokens = tokenizeHTML(text);
//     outputRef.current = "";
//     tokenIndexRef.current = 0;
//     charIndexRef.current = 0;

//     const type = () => {
//       const currentToken = tokens[tokenIndexRef.current];
//       if (!currentToken) {
//         onComplete?.();
//         return;
//       }

//       if (currentToken.type === "tag") {
//         outputRef.current += currentToken.value;
//         setDisplayed(outputRef.current);
//         tokenIndexRef.current++;
//         type();
//       } else {
//         const textPart = currentToken.value;
//         if (charIndexRef.current < textPart.length) {
//           outputRef.current += textPart[charIndexRef.current];
//           setDisplayed(outputRef.current);
//           charIndexRef.current++;
//           typingTimeout.current = setTimeout(type, 30);
//         } else {
//           charIndexRef.current = 0;
//           tokenIndexRef.current++;
//           type();
//         }
//       }
//     };

//     type();
//     return () => clearTimeout(typingTimeout.current);
//   }, [text, animate, onComplete]);

//   return <span dangerouslySetInnerHTML={{ __html: displayed }} />;
// }

// // helper
// function tokenizeHTML(input) {
//   const regex = /(<[^>]+>)|([^<]+)/g;
//   const tokens = [];
//   let match;
//   while ((match = regex.exec(input))) {
//     if (match[1]) tokens.push({ type: "tag", value: match[1] });
//     if (match[2]) tokens.push({ type: "text", value: match[2] });
//   }
//   return tokens;
// }
// code : 3 end

import React, { useEffect, useState } from "react";

export default function TypingEffect({ text, speed = 50, onComplete }) {
  const [displayed, setDisplayed] = useState("");

  useEffect(() => {
    let tokens = tokenizeHTML(text);
    let output = "";
    let tokenIndex = 0;
    let charIndex = 0;
    let interval;

    const type = () => {
      if (tokenIndex >= tokens.length) {
        clearInterval(interval);
        if (onComplete) onComplete();
        return;
      }

      const token = tokens[tokenIndex];

      if (token.type === "tag") {
        // Instantly append the tag
        output += token.value;
        setDisplayed(output);
        tokenIndex++;
      } else if (token.type === "text") {
        // Type text character by character
        if (charIndex < token.value.length) {
          output += token.value[charIndex];
          setDisplayed(output);
          charIndex++;
        } else {
          charIndex = 0;
          tokenIndex++;
        }
      }
    };

    interval = setInterval(type, speed);

    return () => clearInterval(interval);
  }, [text, speed, onComplete]);

  return <span dangerouslySetInnerHTML={{ __html: displayed }} />;
}

function tokenizeHTML(input) {
  const regex = /(<[^>]+>)|([^<]+)/g;
  const tokens = [];
  let match;
  while ((match = regex.exec(input))) {
    if (match[1]) tokens.push({ type: "tag", value: match[1] });
    if (match[2]) tokens.push({ type: "text", value: match[2] });
  }
  return tokens;
}
